import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const GET_LOBS_SUCCESS = 'GET_LOBS_SUCCESS';
export const GET_LOBS_FAILURE = 'GET_LOBS_FAILURE';

function receive(lobs) {
  return {
    type: GET_LOBS_SUCCESS,
    lobs
  };
}

function reject() {
  return {
    type: GET_LOBS_FAILURE
  };
}

export function getLobs() {
  return (dispatch) => {
    const promise = () => ApiService
      .getLobs()
      .then((response) => {
        dispatch(receive(response.data));
      }).catch((error) => {
        if (!error.response) {
          ApiService.addQueuedPromise(promise, error);
        } else if (error.retries && error.retries > 1) {
          dispatch(handleException(error, reject, false));
        }
      });
    return promise();
  };
}
